import React from 'react';

function AppLogo () { return <div className="appLogo" />; }

export default AppLogo;
